export default __webpack_public_path__ + "static/media/four.3f5309b4.svg";